import React from 'react';

const Card = ({ title, children, style }) => {
  return (
    <div className="card" style={style}>
      {title && <h2 className="card-title">{title}</h2>}
      {children}
    </div>
  );
};

export default Card;